module.exports = __webpack_public_path__ + "static/media/coin.43794311.png";